var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"align-middle d-print-none",class:'text-' + _vm.theme},[_c('div',{staticClass:"spinner-border text-center align-middle",class:{
      'spinner-border-sm': _vm.isSm
    },attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Updating...")])]),_vm._v(" "),_c('span',{staticClass:"align-middle pl-2 d-print-none"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }